<template>
  <div class="calico-data-confidence">
    <div
      class="label--small"
      :class="colorClass"
    >
      {{ normalizedConfidence }}
    </div>
  </div>
</template>

<script>
import { DataConfidence } from '@/enums'

function normalizeConfidence(raw) {
  if (!raw) return DataConfidence.UNAVAILABLE
  const s = String(raw).toLowerCase().trim()
  switch (s) {
    case 'high': return DataConfidence.HIGH
    case 'medium': return DataConfidence.MEDIUM
    case 'low': return DataConfidence.LOW
    default: return DataConfidence.UNAVAILABLE
  }
}

export default {
  name: 'CalicoDataConfidence',
  props: {
    dataConfidence: {
      type: String,
      default: ''
    }
  },
  computed: {
    normalizedConfidence() {
      return normalizeConfidence(this.dataConfidence)
    },
    colorClass() {
      switch (this.normalizedConfidence) {
        case DataConfidence.HIGH: return 'confidence-high'
        case DataConfidence.MEDIUM: return 'confidence-medium'
        case DataConfidence.LOW: return 'confidence-low'
        case DataConfidence.UNAVAILABLE: return 'confidence-unavailable'
        default: return 'confidence-unavailable'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.calico-data-confidence {
  .confidence-high        { color: $color-green; }
  .confidence-medium      { color: $color-yellow; }
  .confidence-low         { color: $color-pink; }
  .confidence-unavailable { color: $color-neutral-light; }
}
</style>
